var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":_vm.loadForm}},[_c('a',[(!_vm.is_load)?_c('i',{staticClass:"fa fa-cogs"}):_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v("\n\t\t"+_vm._s(_vm.get_name_form(_vm.form))+"\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb735c3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order-of-service/components/btnLoadSmartForm.vue
// module id = null
// module chunks = 